import React from "react";
import DataTable from "react-data-table-component";

import { useInviteMembersContext } from "../../../contexts/InviteMembersContext";
import { columns } from "./columns";

export default function Table() {
  const { dispatch, actions, state } = useInviteMembersContext();

  const rowSelectCritera = (row) => state.selectedMemberIds.includes(row.id);

  const handleRowSelected = React.useCallback((state) => {
    actions.setSelected(
      dispatch,
      state.selectedRows.map((item) => item.id)
    );
  }, []);

  return (
    <div className="datatable-style">
      <DataTable
        title=""
        columns={columns}
        data={state.members || []}
        noDataComponent="No matching records found"
        persistTableHead={true}
        selectableRows
        selectableRowSelected={rowSelectCritera}
        onSelectedRowsChange={handleRowSelected}
        pagination
        paginationComponentOptions={{
          selectAllRowsItem: true,
          selectAllRowsItemText: "All",
        }}
      />
    </div>
  );
}
